import { render } from "./userManageServer.vue?vue&type=template&id=eb67dc5c&scoped=true"
import script from "./userManageServer.vue?vue&type=script&lang=js"
export * from "./userManageServer.vue?vue&type=script&lang=js"

import "./userManageServer.vue?vue&type=style&index=0&id=eb67dc5c&scoped=true&lang=css"

import exportComponent from "E:\\Apangu\\TdServerMiniAppPortalWeb\\TdServerMiniAppPortalWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb67dc5c"]])

export default __exports__